import {
  fireAddToCartGAEvent,
  fireMemberFavoriteCartGAEvent,
  fireViewCartEvent,
} from '@global/gtm/base';

/**
 * 商品資訊物件
 * @typedef {Object} productInfo
 * @property {string} item_id - 商品編號
 * @property {string} item_name - 商品名稱
 * @property {number} index - 商品索引值
 * @property {string} affiliation - 商品顏色
 * @property {string} [item_brand] - 商品尺寸
 * @property {string} item_list_name - 加入商品的頁面
 * @property {number} price - 商品價格
 * @property {number} quantity - 商品數量
 * @property {string} item_variant - 商品貨號
 */

export function fireAddToCart(productInfo) {
  const itemCategory = window.ItemCategories || undefined;

  productInfo.item_category = itemCategory && itemCategory[0] ? itemCategory[0] : '';
  productInfo.item_category2 = itemCategory && itemCategory[1] ? itemCategory[1] : '';
  productInfo.item_category3 = itemCategory && itemCategory[2] ? itemCategory[2] : '';
  productInfo.item_category4 = itemCategory && itemCategory[3] ? itemCategory[3] : '';

  fireAddToCartGAEvent({
    value: productInfo.price,
    items: [productInfo],
  });

  // 為了購物車第一步需要商品類別資料
  const ECDataLayer = JSON.parse(localStorage.getItem('ECDataLayer'));

  if (ECDataLayer) {
    const alreadyExist = ECDataLayer.find((item) => {
      return item.customMarketID === productInfo.item_id;
    });

    if (!alreadyExist) {
      ECDataLayer.push({
        customMarketID: productInfo.item_id || '',
        itemCategory: window.ItemCategories || [],
      });

      localStorage.setItem('ECDataLayer', JSON.stringify(ECDataLayer));
    }
  } else {
    localStorage.setItem(
      'ECDataLayer',
      JSON.stringify([
        {
          customMarketID: productInfo.item_id || '',
          itemCategory: window.ItemCategories || [],
        },
      ]),
    );
  }
}

export function fireMemberFavoriteAddToCart(productInfo) {
  const itemCategory = window.ItemCategories || undefined;
  const { productId, productName, addFavoriteItem } = productInfo;

  if (itemCategory) {
    addFavoriteItem.item_category = window.ItemCategories[0] || '';
    addFavoriteItem.item_category2 = window.ItemCategories[1] || '';
    addFavoriteItem.item_category3 = window.ItemCategories[2] || '';
    addFavoriteItem.item_category4 = window.ItemCategories[3] || '';
  }

  fireMemberFavoriteCartGAEvent({
    productId,
    productName,
    addFavoriteItem,
  });
}

export function fireViewMiniCart(minCartInfo) {
  const { generalMarketProducts, refrigerationMarketProducts, freezingMarketProducts } =
    minCartInfo;

  const combineArray = [
    ...generalMarketProducts,
    ...refrigerationMarketProducts,
    ...freezingMarketProducts,
  ];
  const userItems = [];
  let price = 0;

  combineArray.forEach((product, index) => {
    price += product.SellPrice;

    const item = {
      index,
      item_id: product.CustomMarketID,
      item_name: product.Name,
      item_category: undefined,
      item_category2: undefined,
      affiliation: product.ColorName,
      item_brand: product.Size,
      quantity: product.Count,
      price: product.SellPrice,
      item_variant: product.BarCode,
      item_list_name: '購物車',
    };

    userItems.push(item);
  });

  fireViewCartEvent({
    value: price,
    items: userItems,
  });
}
